import React from "react";

import { useTranslation } from "react-i18next";

import Fade from 'react-reveal/Fade';

import trade from '../../img/trade.png'

function Features () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative max-w-[1220px] mx-[20px] xl:mx-auto mt-[80px] xl:mt-[120px]">
            <div className="flex flex-col-reverse xl:flex-row items-center justify-between">
                <img src={trade} alt="" className="mt-[20px] xl:mt-0"/>
                <div className="xl:max-w-[550px]">
                    <p className="manrope text-[20px] xl:text-[35px] font-[500] leading-[1.2] text-black">{t('home.20')}</p>
                    <p className="roboto text-[14px] text-[#000000B2] mt-[20px] xl:mt-[40px]">{t('home.21')}</p>
                    <p className="manrope text-[20px] xl:text-[35px] font-[500] leading-[1.2] text-black mt-[20px] xl:mt-[40px]">{t('home.22')}</p>
                    <p className="roboto text-[14px] text-[#000000B2] mt-[20px] xl:mt-[40px]">{t('home.23')}</p>
                </div>
            </div>
        </div>
    );
}

export default Features;